import {action, IObservableArray, makeObservable, observable} from "mobx"
import {MAIN_PAGE} from '@app/enums';
import {FC} from "react";

export class GlobalStorage {

    constructor() {
        makeObservable(this);
    }
    @observable openModule: MAIN_PAGE = MAIN_PAGE.LOGOUT;


    @observable openModalError: boolean = false;

    @observable LogOutIconClicked: boolean = false;
    @observable ConfirmSelectDiffTranslateIconClicked: boolean = false;
    @observable SelfConfIconClicked: boolean = false;
    @observable SelectDiffTranslateIconClicked: boolean = false;
    @observable openErrorUnAuthenticated: boolean = false;

    functionsButton: IObservableArray<FC> = observable.array<FC>([], {deep: false});

    @action
    handleOpenModalError() {
        this.openModalError = !this.openModalError
    }

    @action
    handleCloseModalError() {
        this.openModalError = false
    }

    @action
    handleOpenErrorUnAuthenticated() {
        this.openErrorUnAuthenticated = !this.openErrorUnAuthenticated
    }

    @action
    handleCloseErrorUnauthenticated() {
        this.openErrorUnAuthenticated = false
    }
}
